import React, { useEffect } from 'react';
import { X, ShoppingBag } from 'lucide-react';
import { Button } from './ui/button';

const ThemeModal = ({ theme, isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!theme) return null;

  const handleAddToCart = (item) => {
    console.log('Added to cart:', item);
    alert(`${item.name} added to cart!`);
  };

  return (
    <>
      <div 
        className={`modal-overlay ${isOpen ? 'active' : ''}`}
        onClick={onClose}
      ></div>
      
      <div className={`theme-modal ${isOpen ? 'active' : ''}`}>
        <button className="modal-close" onClick={onClose}>
          <X className="w-6 h-6" />
        </button>

        <div className="modal-header">
          <div className="modal-header-content">
            <h2 className="modal-title">{theme.name}</h2>
            <p className="modal-tagline">{theme.tagline}</p>
            <p className="modal-description">{theme.description}</p>
            
            {theme.features && (
              <div className="theme-features">
                <h4 className="features-heading">What's Included:</h4>
                <ul className="features-list">
                  {theme.features.map((feature, idx) => (
                    <li key={idx} className="feature-item">✨ {feature}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="modal-cta-section">
          <h3 className="modal-cta-title">Ready to Make This Happen? 🎁</h3>
          <p className="modal-cta-text">
            Fill out our inquiry form below and let us know you want the <strong>{theme.name}</strong> vibe! 
            We'll take it from there and make your gift absolutely stunning.
          </p>
          <Button 
            onClick={() => {
              onClose();
              setTimeout(() => {
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
              }, 300);
            }}
            className="modal-cta-button"
          >
            Get Started Now →
          </Button>
        </div>
      </div>
    </>
  );
};

export default ThemeModal;
